import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Search, ChevronDown, Edit, ArrowLeft } from 'lucide-react';
const HubSpotListDetail: React.FC = () => {
  const {
    id
  } = useParams<{
    id: string;
  }>();
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('filters');
  // Mock alerts data
  const alertsData = [{
    id: 1,
    name: 'Potential Analytics Upsell (High Manual Reporting)',
    description: 'Flags accounts doing heavy manual analysis, suggesting they\'re ready for the "Advanced Analytics" package.',
    category: 'Upsell & Expansion',
    matches: 5,
    lastRun: '2 hours ago',
    status: 'Active',
    size: 5,
    type: 'Active',
    object: 'Contact',
    lastUpdated: 'Apr 19, 2025 12:39 AM',
    creator: 'Jimmy J. Carter',
    folder: '-',
    usedCount: 0
  }, {
    id: 2,
    name: 'Potential Brand Portal Upsell (Brand Filter Usage)',
    description: 'Identifies accounts providing reports to external partners, signaling a need for "Brand Portals".',
    category: 'Upsell & Expansion',
    matches: 8,
    lastRun: '1 day ago',
    status: 'Active',
    size: 8,
    type: 'Active',
    object: 'Contact',
    lastUpdated: 'Apr 18, 2025 2:55 PM',
    creator: 'Jimmy J. Carter',
    folder: '-',
    usedCount: 0
  }, {
    id: 3,
    name: 'User Overage - License Limit Exceeded',
    description: 'A direct expansion signal that an account has added more users than their subscription allows and needs to be billed for the overage.',
    category: 'Upsell & Expansion',
    matches: 3,
    lastRun: '12 hours ago',
    status: 'Active',
    size: 3,
    type: 'Active',
    object: 'Contact',
    lastUpdated: 'Apr 18, 2025 2:55 PM',
    creator: 'Jimmy J. Carter',
    folder: '-',
    usedCount: 0
  }, {
    id: 4,
    name: 'Manufacturer Not Using Assemblies',
    description: 'A critical alert for a key persona not using a sticky feature, indicating a major onboarding failure or churn risk.',
    category: 'Churn & Onboarding Risk',
    matches: 7,
    lastRun: '6 hours ago',
    status: 'Active',
    size: 7,
    type: 'Active',
    object: 'Contact',
    lastUpdated: 'Apr 18, 2025 2:55 PM',
    creator: 'Jimmy J. Carter',
    folder: '-',
    usedCount: 0
  }, {
    id: 5,
    name: 'High-Value Account is Underusing the Platform',
    description: 'Flags high-MRR customers who are dangerously disengaged from the product, requiring immediate proactive outreach to prevent churn.',
    category: 'Churn & Onboarding Risk',
    matches: 2,
    lastRun: '1 day ago',
    status: 'Active',
    size: 2,
    type: 'Static',
    object: 'Contact',
    lastUpdated: 'Apr 18, 2025 2:55 PM',
    creator: 'Jimmy J. Carter',
    folder: '-',
    usedCount: 0
  }, {
    id: 6,
    name: 'Distributor with Unusually Low Sales Volume',
    description: 'Identifies a distributor whose sales volume is below the expected baseline for their persona, suggesting a potential business or adoption problem.',
    category: 'Churn & Onboarding Risk',
    matches: 4,
    lastRun: '8 hours ago',
    status: 'Active',
    size: 4,
    type: 'Active',
    object: 'Contact',
    lastUpdated: 'Apr 18, 2025 2:55 PM',
    creator: 'Jimmy J. Carter',
    folder: '-',
    usedCount: 0
  }, {
    id: 7,
    name: 'Small Customer Using E-commerce Menu Exclusively',
    description: 'A strategic alert for the product team that identifies customers who are essentially buying the entire platform for one feature, signaling a potential to modularize that feature into a new product.',
    category: 'Product & Strategy',
    matches: 6,
    lastRun: '3 hours ago',
    status: 'Active',
    size: 6,
    type: 'Active',
    object: 'Contact',
    lastUpdated: 'Apr 18, 2025 2:55 PM',
    creator: 'Jimmy J. Carter',
    folder: '-',
    usedCount: 0
  }];
  // Find the current alert
  const currentAlert = alertsData.find(alert => alert.id === parseInt(id || '1')) || alertsData[0];
  // Mock contacts data
  const contactsData = [{
    id: 1,
    name: 'Chensterman Chen',
    email: 'chen@swipesafe.com',
    phone: '--',
    company: 'SwipeSafe',
    lastActivity: 'Apr 19, 2025 12:39 AM',
    owner: 'No owner'
  }, {
    id: 2,
    name: 'Hovan Ngo',
    email: 'hovan@leasa.com',
    phone: '--',
    company: 'Leasa',
    lastActivity: 'Apr 19, 2025 12:39 AM',
    owner: 'No owner'
  }, {
    id: 3,
    name: 'Albert Feng-En Tsai',
    email: 'albert@askg.com',
    phone: '--',
    company: 'Ask G',
    lastActivity: 'Apr 19, 2025 12:39 AM',
    owner: 'No owner'
  }, {
    id: 4,
    name: 'Ethan Bidna',
    email: 'ethan@askg.com',
    phone: '--',
    company: 'Ask G',
    lastActivity: 'Apr 19, 2025 12:39 AM',
    owner: 'No owner'
  }, {
    id: 5,
    name: 'Jimmy Mayer',
    email: 'jimmy@loreboard.com',
    phone: '--',
    company: 'LoreBoard',
    lastActivity: 'Apr 19, 2025 12:39 AM',
    owner: 'No owner'
  }, {
    id: 6,
    name: 'PalashAwasthi05 Awast',
    email: 'palash@idiots.ai',
    phone: '--',
    company: 'Idiots.ai',
    lastActivity: 'Apr 19, 2025 12:39 AM',
    owner: 'No owner'
  }, {
    id: 7,
    name: 'Alex DeNuzzo',
    email: 'alex@laminar.com',
    phone: '--',
    company: 'Laminar',
    lastActivity: 'Apr 19, 2025 12:39 AM',
    owner: 'No owner'
  }];
  // Limit contacts to the size of the alert
  const limitedContacts = contactsData.slice(0, currentAlert.size);
  const handleContactClick = (contactId: number) => {
    navigate(`/hubspot/contacts/${contactId}?alertId=${id}`);
  };
  return <div className="bg-white min-h-screen" data-id="element-1284">
      {/* HubSpot-like header */}
      <div className="border-b border-gray-200 bg-[#33475b] text-white py-2 px-4 flex items-center justify-between" data-id="element-1285">
        <div className="flex items-center" data-id="element-1286">
          <div className="mr-4" data-id="element-1287">
            <svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor" data-id="element-1288">
              <path d="M22.447 10.105h-6.225v-1.293h6.225v1.293zm-6.225 4.278h6.225v-1.293h-6.225v1.293zm0 4.278h6.225v-1.293h-6.225v1.293zm-7.437-2.985a3.026 3.026 0 0 1-3.022-3.022 3.026 3.026 0 0 1 3.022-3.022 3.026 3.026 0 0 1 3.022 3.022 3.026 3.026 0 0 1-3.022 3.022m0-8.557a5.542 5.542 0 0 0-5.535 5.535 5.542 5.542 0 0 0 5.535 5.535 5.542 5.542 0 0 0 5.535-5.535 5.542 5.542 0 0 0-5.535-5.535m-5.535-3.022h4.242V1.855H3.25v4.242h4.242z" data-id="element-1289" />
            </svg>
          </div>
          <div className="relative" data-id="element-1290">
            <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" size={16} data-id="element-1291" />
            <input type="text" placeholder="Search HubSpot" className="bg-[#496b8a] text-white placeholder-gray-300 rounded pl-10 pr-4 py-1.5 focus:outline-none focus:ring-2 focus:ring-blue-500" data-id="element-1292" />
            <span className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-300 text-xs" data-id="element-1293">
              Ctrl K
            </span>
          </div>
        </div>
        <div className="flex items-center space-x-4" data-id="element-1294">
          <button className="text-white" data-id="element-1295">
            <span className="sr-only" data-id="element-1296">Notifications</span>
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-1297">
              <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9" data-id="element-1298"></path>
              <path d="M13.73 21a2 2 0 0 1-3.46 0" data-id="element-1299"></path>
            </svg>
          </button>
          <div className="flex items-center" data-id="element-1300">
            <span className="text-sm font-medium mr-2" data-id="element-1301">Daemo AI</span>
            <div className="bg-blue-500 text-white rounded-full w-8 h-8 flex items-center justify-center" data-id="element-1302">
              DA
            </div>
          </div>
        </div>
      </div>
      {/* Back link and list header */}
      <div className="p-6" data-id="element-1303">
        <div className="mb-4" data-id="element-1304">
          <button onClick={() => navigate('/hubspot')} className="text-blue-600 hover:text-blue-800 text-sm flex items-center" data-id="element-1305">
            <ArrowLeft size={14} className="mr-1" data-id="element-1306" /> Back to lists
          </button>
        </div>
        <div className="flex justify-between items-center mb-4" data-id="element-1307">
          <div className="flex items-center" data-id="element-1308">
            <h1 className="text-2xl font-medium text-gray-800 mr-2" data-id="element-1309">
              {currentAlert.name}
            </h1>
            <button className="text-blue-600 hover:text-blue-800" data-id="element-1310">
              <Edit size={16} data-id="element-1311" />
            </button>
          </div>
          <div className="flex space-x-2" data-id="element-1312">
            <button className="border border-gray-300 rounded px-3 py-1.5 text-sm text-gray-700 hover:bg-gray-50" data-id="element-1313">
              Details
            </button>
            <button className="border border-gray-300 rounded px-3 py-1.5 text-sm flex items-center text-gray-700 hover:bg-gray-50" data-id="element-1314">
              Actions <ChevronDown size={14} className="ml-1" data-id="element-1315" />
            </button>
          </div>
        </div>
        <div className="flex items-center mb-4" data-id="element-1316">
          <div className={`flex items-center justify-center rounded-full w-6 h-6 mr-2 ${currentAlert.type === 'Active' ? 'bg-green-100 text-green-600' : 'bg-gray-100 text-gray-600'}`} data-id="element-1317">
            <span className="text-xs" data-id="element-1318">
              {currentAlert.type === 'Active' ? 'A' : 'S'}
            </span>
          </div>
          <span className="text-sm font-medium text-gray-700 uppercase" data-id="element-1319">
            {currentAlert.type}
          </span>
          <span className="mx-2 text-gray-400" data-id="element-1320">•</span>
          <span className="text-sm text-gray-700" data-id="element-1321">
            Size: {currentAlert.size} contacts
          </span>
        </div>
        {/* Tabs */}
        <div className="border-b border-gray-200 mb-4" data-id="element-1322">
          <button className={`py-2 px-4 text-sm font-medium ${activeTab === 'filters' ? 'border-b-2 border-blue-500 text-blue-600' : 'text-gray-600'}`} onClick={() => setActiveTab('filters')} data-id="element-1323">
            Filters
          </button>
          <button className={`py-2 px-4 text-sm font-medium ${activeTab === 'performance' ? 'border-b-2 border-blue-500 text-blue-600' : 'text-gray-600'}`} onClick={() => setActiveTab('performance')} data-id="element-1324">
            Performance
          </button>
          <button className={`py-2 px-4 text-sm font-medium ${activeTab === 'activity' ? 'border-b-2 border-blue-500 text-blue-600' : 'text-gray-600'}`} onClick={() => setActiveTab('activity')} data-id="element-1325">
            Activity
          </button>
          <button className={`py-2 px-4 text-sm font-medium ${activeTab === 'settings' ? 'border-b-2 border-blue-500 text-blue-600' : 'text-gray-600'}`} onClick={() => setActiveTab('settings')} data-id="element-1326">
            Settings
          </button>
        </div>
        {/* Filters section */}
        <div className="mb-6" data-id="element-1327">
          <div className="flex justify-between items-center mb-4" data-id="element-1328">
            <h2 className="text-sm font-medium text-gray-700" data-id="element-1329">Filters</h2>
            <div className="flex space-x-2" data-id="element-1330">
              <button className="border border-gray-300 rounded px-3 py-1.5 text-xs text-gray-700 hover:bg-gray-50" data-id="element-1331">
                Test contact
              </button>
              <button className="border border-gray-300 rounded px-3 py-1.5 text-xs text-gray-700 hover:bg-gray-50" data-id="element-1332">
                Edit filters
              </button>
            </div>
          </div>
          <div className="bg-gray-50 border border-gray-200 rounded-md p-4 text-center" data-id="element-1333">
            <p className="text-sm text-gray-600" data-id="element-1334">
              This list doesn't have any filters
            </p>
            <button className="mt-2 text-xs text-white bg-blue-600 hover:bg-blue-700 rounded px-3 py-1" data-id="element-1335">
              Add filter
            </button>
          </div>
        </div>
        {/* Search and contacts table */}
        <div className="mb-4" data-id="element-1336">
          <div className="flex justify-between items-center mb-4" data-id="element-1337">
            <div className="relative" data-id="element-1338">
              <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" size={16} data-id="element-1339" />
              <input type="text" placeholder="Search in list" className="border border-gray-300 rounded pl-10 pr-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500" data-id="element-1340" />
            </div>
            <div className="flex space-x-2" data-id="element-1341">
              <button className="border border-gray-300 rounded px-3 py-1.5 text-sm text-gray-700 hover:bg-gray-50" data-id="element-1342">
                Export list
              </button>
              <button className="border border-gray-300 rounded px-3 py-1.5 text-sm text-gray-700 hover:bg-gray-50" data-id="element-1343">
                Edit columns
              </button>
            </div>
          </div>
          <div className="border border-gray-200 rounded-md overflow-hidden" data-id="element-1344">
            <table className="min-w-full divide-y divide-gray-200" data-id="element-1345">
              <thead className="bg-gray-50" data-id="element-1346">
                <tr data-id="element-1347">
                  <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1348">
                    <input type="checkbox" className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded" data-id="element-1349" />
                  </th>
                  <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1350">
                    Name
                  </th>
                  <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1351">
                    Email
                  </th>
                  <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1352">
                    Phone Number
                  </th>
                  <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1353">
                    Contact Owner
                  </th>
                  <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1354">
                    Primary Associated Company
                  </th>
                  <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1355">
                    Last Activity
                  </th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200" data-id="element-1356">
                {limitedContacts.map(contact => <tr key={contact.id} className="hover:bg-gray-50 cursor-pointer" onClick={() => handleContactClick(contact.id)} data-id="element-1357">
                    <td className="px-6 py-4 whitespace-nowrap" data-id="element-1358">
                      <input type="checkbox" className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded" data-id="element-1359" />
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap" data-id="element-1360">
                      <div className="flex items-center" data-id="element-1361">
                        <div className="flex-shrink-0 h-8 w-8 bg-gray-200 rounded-full flex items-center justify-center text-gray-600" data-id="element-1362">
                          {contact.name.charAt(0)}
                        </div>
                        <div className="ml-4" data-id="element-1363">
                          <div className="text-sm font-medium text-blue-600 hover:underline" data-id="element-1364">
                            {contact.name}
                          </div>
                        </div>
                      </div>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap" data-id="element-1365">
                      <div className="text-sm text-gray-900" data-id="element-1366">
                        {contact.email || '--'}
                      </div>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap" data-id="element-1367">
                      <div className="text-sm text-gray-900" data-id="element-1368">
                        {contact.phone}
                      </div>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap" data-id="element-1369">
                      <div className="text-sm text-gray-900" data-id="element-1370">
                        {contact.owner}
                      </div>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap" data-id="element-1371">
                      <div className="text-sm text-blue-600 hover:underline" data-id="element-1372">
                        {contact.company}
                      </div>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap" data-id="element-1373">
                      <div className="text-sm text-gray-900" data-id="element-1374">
                        {contact.lastActivity}
                      </div>
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>
          {/* Pagination */}
          <div className="flex items-center justify-between mt-4" data-id="element-1375">
            <div className="flex items-center text-sm text-gray-700" data-id="element-1376">
              <button className="px-2 py-1 border border-gray-300 rounded-l-md bg-white text-gray-500 hover:bg-gray-50 disabled:opacity-50" data-id="element-1377">
                Prev
              </button>
              <button className="px-3 py-1 border-t border-b border-gray-300 bg-blue-50 text-blue-600" data-id="element-1378">
                1
              </button>
              <button className="px-2 py-1 border border-gray-300 rounded-r-md bg-white text-gray-500 hover:bg-gray-50" data-id="element-1379">
                Next
              </button>
            </div>
            <div className="flex items-center" data-id="element-1380">
              <span className="text-sm text-gray-700 mr-2" data-id="element-1381">25 per page</span>
              <ChevronDown size={14} data-id="element-1382" />
            </div>
          </div>
        </div>
      </div>
    </div>;
};
export default HubSpotListDetail;